{
    "Accessibility Menu": "アクセシビリティメニュー",
    "Reset settings": "設定をリセット",
    "Close": "閉じる",
    "Content Adjustments": "コンテンツ調整",
    "Adjust Font Size": "フォントサイズを調整",
    "Highlight Title": "タイトルを強調表示",
    "Highlight Links": "リンクを強調表示",
    "Readable Font": "読みやすいフォント",
    "Color Adjustments": "色の調整",
    "Dark Contrast": "ダークコントラスト",
    "Light Contrast": "ライトコントラスト",
    "High Contrast": "高いコントラスト",
    "High Saturation": "彩度が高い",
    "Low Saturation": "彩度が低い",
    "Monochrome": "モノクローム",
    "Protanopia": "1型色覚（赤緑色盲）",
    "Deuteranopia": "2型色覚（緑赤色盲）",
    "Tritanopia": "3型色覚（青黄色盲）",
    "Visual & Navigation Aids": "視覚・ナビゲーション支援",
    "Additional Tools": "その他のツール",
    "Reading Guide": "読み上げガイド",
    "Stop Animations": "アニメーションを停止",
    "Big Cursor": "大きなカーソル",
    "Screen Reader": "スクリーンリーダー",
    "Hide Images": "画像を非表示",
    "Image Tooltips": "画像ツールチップ",
    "Page Structure": "ページ構造",
    "Super Focus": "スーパーフォーカス",
    "Magnifier": "虫眼鏡",
    "Increase Font Size": "フォントサイズを大きくする",
    "Decrease Font Size": "フォントサイズを小さくする",
    "Letter Spacing": "文字間隔",
    "Line Height": "行の高さ",
    "Font Weight": "フォントの太さ",
    "Dyslexia Font": "ディスレクシア用フォント",
    "Language": "言語",
    "Open Accessibility Menu": "アクセシビリティメニューを開く",
    "Accessibility Profiles": "アクセシビリティプロファイル",
    "Seizure Safe Profile": "けいれん安全プロファイル",
    "Stops animations and reduces color saturation.": "アニメーションを停止し、色の彩度を下げます。",
    "Blind Profile": "視覚障害者プロファイル",
    "Activates the screen reader for auditory navigation.": "スクリーンリーダーを起動して音声ナビゲーションを行います。",
    "Visually Impaired Profile": "弱視プロファイル",
    "Enhances contrast and readability for low vision.": "弱視のためのコントラストと読みやすさを向上させます。",
    "ADHD Friendly Profile": "ADHD対応プロファイル",
    "Reduces distractions for better focus.": "集中力を高めるために散漫さを軽減します。",
    "Cognitive & Learning Profile": "認知・学習プロファイル",
    "Helpful tools for reading and comprehension.": "読解と理解のための便利なツール。",
    "Motor Impaired Profile": "運動障害プロファイル",
    "Optimizes the site for keyboard-only navigation.": "キーボードのみでのナビゲーションに最適化します。",
    "Headings": "見出し",
    "Landmarks": "ランドマーク",
    "Links": "リンク",
    "Focus element": "要素にフォーカス",
    "Visit link": "リンクを開く"
}